let amCartItems = null;
let existingEventListener = null;
const engraveOpen = async (dataPos, el) => {
	const errMsgAvl = document.getElementById('engrave--err-text--input');
	const additionalAttributesDrawer = document.getElementById('additionalAttributesDrawer');
	const dataValue = document.getElementById(`openDrawerButton-${dataPos}`).getAttribute('data-formid');
	const engraveColors = document.getElementById(`openDrawerButton-${dataPos}`).getAttribute('data-engravecolors');
	const engraveImage = document.getElementById(`openDrawerButton-${dataPos}`).getAttribute('data-engraveimage');
	const engraveCharacterCount = document
		.getElementById(`openDrawerButton-${dataPos}`)
		.getAttribute('data-engravecharactercount');
	const productType = el.getAttribute('data-product-type');
	const variant = el.closest('dl').querySelector('[data-selected-option]').getAttribute('data-selected-option');
	let engraveInputTextbox = document.getElementById('engrave-name-input');
	const tooltip = el.getAttribute('data-tooltip');
	const engraveTooltip = document.querySelector('.tooltip');
	errMsgAvl ? errMsgAvl.remove() : null;
	const key = await initialCheck(dataPos, engraveColors, engraveImage, engraveCharacterCount);
	additionalAttributesDrawer.classList.add('active');
	$('.engrave-submit-confirm').attr('formid', dataValue);
	engraveInputTextbox.setAttribute('data-engrave-product-type', productType);
	engraveInputTextbox.setAttribute('data-engrave-variant', variant);
	engraveTooltip?.setAttribute('data-tooltip', tooltip);

	$('body').addClass('overflow-hidden');
	$('body').append($('<div class="custom--overlay"></div>'));
	await handleConfirmClick(key, dataPos);
	engraveInput();
	disableEmptyInputs();
	await cartEngraveCharacterLimit(productType, variant);
};

function intiateEngraveOpen() {
	const engraveWrap = document.querySelectorAll('.engrave-cart-wrap');
	engraveWrap.forEach((el) => {
		console.log(el);
		el.addEventListener('click', (e) => {
			console.log('clicked on element');
			e.preventDefault();
			let dataPos = el.getAttribute('data-position');
			engraveOpen(dataPos, el);
		});
	});
}
document.addEventListener('DOMContentLoaded', function () {
	intiateEngraveOpen();
});
// document.addEventListener('click', function () {
// 	intiateEngraveOpen()
// });

///Initial check and fill function

const initialCheck = async (dataPos, engraveColors, imgUrl, engraveCharacterCount) => {
	const idKey = await fetch('/cart.json')
		.then((res) => {
			if (!res.ok) {
				throw new Error('Something went wrong');
			}
			return res.json();
		})
		.then((data) => {
			amCartItems = data.items;
			const properties = data.items[dataPos].properties;
			const key = data.items[dataPos].key;
			const image = document.getElementById('engraveImagePreview');
			image.src = imgUrl;
			const textCount = document.getElementById('engrave_count');
			textCount.innerHTML = engraveCharacterCount;
			const engraveName = document.getElementById('engrave-name-input');
			engraveName.maxLength = engraveCharacterCount;
			const engraveDynamic = document.getElementById('engrave-dynamic');
			if (properties['_engravingText']) {
				engraveName.value = properties['_engravingText'];
				engraveDynamic.innerText = properties['_engravingText'];
			} else {
				engraveName.value = '';
			}

			// Switch statement for enabling/disabling engrave colors
			const disableOptions = ['Gold', 'Silver', 'Neutral', 'Copper'];

			disableOptions.forEach((color) => {
				const input = document.querySelector(`input[type="radio"][value="${color.toLowerCase()}"]`);
				const parentElement = input.parentElement;

				switch (color) {
					case 'Gold':
						input.disabled = !engraveColors.includes(color);
						if (input.disabled) {
							parentElement.classList.add('displayNone');
						} else {
							parentElement.classList.remove('displayNone');
						}
						break;
					case 'Silver':
						input.disabled = !engraveColors.includes(color);
						if (input.disabled) {
							parentElement.classList.add('displayNone');
						} else {
							parentElement.classList.remove('displayNone');
						}
						break;
					case 'Neutral':
						input.disabled = !engraveColors.includes(color);
						if (input.disabled) {
							parentElement.classList.add('displayNone');
						} else {
							parentElement.classList.remove('displayNone');
						}
						break;
					case 'Copper':
						input.disabled = !engraveColors.includes(color);
						if (input.disabled) {
							parentElement.classList.add('displayNone');
						} else {
							parentElement.classList.remove('displayNone');
						}
						break;
					default:
						break;
				}
			});

			const colorRadios = document.querySelectorAll('input[name="properties[_engravingColor]"]');
			colorRadios.forEach((colorRadio) => {
				if (colorRadio.value == properties['_engravingColor']) {
					colorRadio.checked = true;
					const color = colorRadio.getAttribute('data-color');
					engraveDynamic.style.color = color;
				} else {
					colorRadio.checked = false;
				}
			});
			const engraveStyles = document.querySelectorAll('input[name="properties[_engravingStyle]"]');
			if (properties['_engravingStyle']) {
				engraveStyles.forEach((engraveStyle) => {
					if (engraveStyle.value == properties['_engravingStyle']) {
						engraveStyle.checked = true;
						const font = engraveStyle.getAttribute('data-font');
						engraveDynamic.style.fontFamily = font;
					} else {
						engraveStyle.checked = false;
					}
				});
			} else {
				if (engraveStyles.length > 0) {
					engraveStyles[0].checked = true;
				}
			}

			const engraveConsent = document.getElementById('engrave-consent-input');
			engraveConsent.checked = properties['_engravingConfirmation'] === 'on';

			return key;
		});

	return idKey;
};

//confirm button click
const handleConfirmClick = async (key, dataPos) => {
	const confirmBtn = document.getElementById('engrave-consent-confirm');

	if (existingEventListener) {
		confirmBtn.removeEventListener('click', existingEventListener);
	}

	existingEventListener = async (event) => {
		const check = checkEmptyFields();
		if (check == null) {
			const engraveName = document.getElementById('engrave-name-input');
			const engraveConsent = document.getElementById('engrave-consent-input');

			let selectedColorValue = '';
			let colorRadios = document.getElementsByName('properties[_engravingColor]');
			for (let i = 0; i < colorRadios.length; i++) {
				if (colorRadios[i].checked) {
					selectedColorValue = colorRadios[i].value;
					break;
				}
			}

			let selectedStyleValue = '';
			let styleRadios = document.getElementsByName('properties[_engravingStyle]');
			for (let i = 0; i < styleRadios.length; i++) {
				if (styleRadios[i].checked) {
					selectedStyleValue = styleRadios[i].value;
					break;
				}
			}

			let xhr = new XMLHttpRequest();
			xhr.open('POST', '/cart/change.js', true);
			xhr.setRequestHeader('Content-Type', 'application/json');
			let data = JSON.stringify({
				id: key,
				properties: {
					_engravingText: engraveName.value,
					_engravingColor: selectedColorValue,
					_engravingStyle: selectedStyleValue,
					_engravingConfirmation: engraveConsent.checked ? 'on' : '',
					'gift-wrap-color': amCartItems[dataPos]?.properties['gift-wrap-color'],
					'gift-wrap-add-message': amCartItems[dataPos]?.properties['gift-wrap-add-message'],
					'gift-wrap-from': amCartItems[dataPos]?.properties['gift-wrap-from'],
					'gift-wrap-to': amCartItems[dataPos]?.properties['gift-wrap-to'],
					'gift-wrap-message': amCartItems[dataPos]?.properties['gift-wrap-message'],
				},
			});

			xhr.send(data);

			xhr.onreadystatechange = function () {
				if (xhr.readyState === 4 && xhr.status === 200) {
					let cart = JSON.parse(xhr.responseText);
					confirmBtn.removeEventListener('click', existingEventListener);
					existingEventListener = null;
					const engraveClrBtn = document.querySelector(`[data-clear-position="${dataPos}"]`);
					const engraveBtn = document.querySelector(`[data-engrave-position="${dataPos}"]`);
					let parsedData = JSON.parse(data);
					if (parsedData.properties['_engravingConfirmation'] == 'on') {
						engraveClrBtn.style.display = 'block';
						engraveBtn.innerHTML = 'Modify my bottle';
						engraveBtn.parentElement.classList.add('has--content');
					} else {
						engraveClrBtn.style.display = 'none';
						engraveBtn.innerHTML = 'Engrave my bottle';
						engraveBtn.parentElement.classList.remove('has--content');
					}
				} else {
					console.error('Error:', xhr.statusText);
				}
			};
		}
	};

	confirmBtn.addEventListener('click', existingEventListener);
};

//remove all fields - func

const removeAll = () => {
	const clearBtns = document.querySelectorAll('.engrave-cart-clear');
	clearBtns.forEach((clearbtn) => {
		clearbtn.addEventListener('click', async () => {
			let returnFromParent = false;
			const dataPosition = clearbtn.dataset.clearPosition;
			const engraveColors = document
				.getElementById(`openDrawerButton-${dataPosition}`)
				.getAttribute('data-engravecolors');
			const engraveImage = document
				.getElementById(`openDrawerButton-${dataPosition}`)
				.getAttribute('data-engraveimage');
			const engraveCharacterCount = document
				.getElementById(`openDrawerButton-${dataPosition}`)
				.getAttribute('data-engravecharactercount');
			const dataKey = clearbtn.dataset.key;
			$('#myEngraveModal').css('display', 'flex');
			const key = await initialCheck(dataPosition, engraveColors, engraveImage, engraveCharacterCount);
			//remove click
			$(document).on('click', '#engrave-drawer-cancel, #myEngraveModal .close', function () {
				returnFromParent = true;
			});
			$(document).on('click', '#myEngraveModal #remove-gift-wrap', function () {
				if (returnFromParent) {
					return;
				}
				const engravePos = document.querySelector(`[data-engrave-position="${dataPosition}"]`);
				engravePos.innerHTML = 'Engrave my bottle';
				engravePos.parentElement.classList.remove('has--content');
				const engraveClrBtn = document.querySelector(`[data-clear-position="${dataPosition}"]`);
				const itemKey = engraveClrBtn.dataset.key;
				engraveClrBtn.style.display = 'none';
				let xhr = new XMLHttpRequest();
				xhr.open('POST', '/cart/change.js', true);
				xhr.setRequestHeader('Content-Type', 'application/json');
				xhr.onreadystatechange = function () {
					if (xhr.readyState === 4 && xhr.status === 200) {
						let cart = JSON.parse(xhr.responseText);
						// handle the 'cart' object in the success callback as needed
					}
				};
				let engraveData = JSON.stringify({
					id: amCartItems[dataPosition].key,
					properties: {
						_engravingText: '',
						_engravingStyle: '',
						_engravingColor: '',
						_engravingConfirmation: '',
						'gift-wrap-color': amCartItems[dataPosition]?.properties['gift-wrap-color'],
						'gift-wrap-add-message': amCartItems[dataPosition]?.properties['gift-wrap-add-message'],
						'gift-wrap-from': amCartItems[dataPosition]?.properties['gift-wrap-from'],
						'gift-wrap-to': amCartItems[dataPosition]?.properties['gift-wrap-to'],
						'gift-wrap-message': amCartItems[dataPosition]?.properties['gift-wrap-message'],
					},
				});
				xhr.send(engraveData);
			});
		});
	});
};
removeAll();

// Define the click function
const EngravecloseModal = (event) => {
	event.preventDefault();
	document.getElementById('myEngraveModal').style.display = 'none';
};

let cancelButton = document.querySelector('#myEngraveModal .close');
cancelButton?.addEventListener('click', EngravecloseModal);

const cartEngraveStyleRadioButtons = document.querySelectorAll('input[name="properties[_engravingStyle]"]');
let engraveInputTextbox = document.getElementById('engrave-name-input');
const cartErrMsgParent = document.querySelector('#text-slick.engrave--input');
const cartErrMsgConatiner = document.querySelector('#engrave--err-text--input');
const cartStylSlickContent = document.getElementById('style-slick');
const cartTextSlickContent = document.getElementById('text-slick');

const cartEngraveCharacterLimit = (productType, variant, text) => {
	// const cartErrMsgConatiner= document.querySelector('#engrave--err-text--input');
	const selectedStyle = document
		.querySelector('input[name="properties[_engravingStyle]"]:checked')
		?.getAttribute('data-font-style');
	const engravecharacterlister = document.getElementById('engrave_count');
	const inputValue = text ? text.replace(/\s+/g, '') : engraveInputTextbox.value.replace(/\s+/g, '');
	let font = 'lowercase';
	if (/^[A-Z]+$/.test(inputValue)) {
		font = 'uppercase';
	} else {
		font = 'lowercase';
	}
	const maxLenthValue = `${productType}_${selectedStyle}_${variant}_${font}`;
	const limit = maxLenthValue ? engraveMaxlimit[maxLenthValue] : 8;
	engravecharacterlister.innerHTML = limit;
	return limit;
};

cartEngraveStyleRadioButtons.forEach(function (radioButton) {
	radioButton.addEventListener('change', function () {
		let inputValue = engraveInputTextbox.value;
		const productType = engraveInputTextbox.getAttribute('data-engrave-product-type');
		const variant = engraveInputTextbox.getAttribute('data-engrave-variant');
		let limit = cartEngraveCharacterLimit(productType, variant);

		const textLength = inputValue.length;
		if (textLength > limit) {
			engraveInputTextbox.maxLength = limit;
			const text = inputValue.slice(0, limit);
			limit = cartEngraveCharacterLimit(productType, variant, text);
			text.length > limit ? (engraveInputTextbox.value = text.slice(0, limit)) : (engraveInputTextbox.value = text);
			const dynamicContent = document.getElementById('engrave-dynamic');
			dynamicContent.innerHTML = engraveInputTextbox.value;
			cartErrMsgConatiner
				? null
				: cartErrMsgParent.insertAdjacentHTML(
					'afterbegin',
					"<p id='engrave--err-text--input'>Character limit changed based on the font</p>"
				);
			if (window.innerWidth > 767) {
				cartStylSlickContent.style.display = 'none';
				cartTextSlickContent.style.display = 'block';
			} else {
				const mobileSlider = document.querySelector('.engrave--accordian');
				window.jQuery(mobileSlider).slick('slickGoTo', 1);
			}
		}
	});
});
engraveInputTextbox.addEventListener('keyup', (event) => {
	const productType = engraveInputTextbox.getAttribute('data-engrave-product-type');
	const variant = engraveInputTextbox.getAttribute('data-engrave-variant');
	const limit = cartEngraveCharacterLimit(productType, variant);
	engraveInputTextbox.maxLength = limit;
	engraveInputTextbox.value = engraveInputTextbox.value.slice(0, limit);
});
engraveInputTextbox.addEventListener('click', (e) => {
	const errMsgConatiner = document.querySelector('#engrave--err-text--input');
	errMsgConatiner?.remove();
});
